module.exports = __webpack_public_path__ + "img/news-small-1.df9f1169.png";